import React from 'react';
import './style.scss';
import classnames from "classnames";
import {useDispatch} from "react-redux";
import {createAction} from "../../../utils/sagaHelper.js";
import {ORDERING_MENU_DELIVERY_ZONES_GLOBAL_EDIT_RESET} from "../../../store/reducers/restaurant/restaurant-actions.js";
import IconButton from "../IconButton/index.js";
import {useTranslation} from "react-i18next";
import {currentUserIsDepotRole} from "../../../services/userModel.js";

export const ResetDepotGlobalPriceValue = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const handleOnClick = () => {
        dispatch(createAction(ORDERING_MENU_DELIVERY_ZONES_GLOBAL_EDIT_RESET, props));
    }

    return (
        <div className={classnames('resetDepotGlobalPriceValue', {changedValue: !currentUserIsDepotRole() && props.data[props.override]})}
        >
            <span>{props[props.accessor]}</span>
            {props.data[props.override] && !currentUserIsDepotRole() && (
                <IconButton isIcon onClick={handleOnClick} iconName={'resetIcon'} tooltipText={t(props.tooltipText)}/>
            )}
        </div>
    )
}